import browser from '@openclassrooms/utils/browser';

function toggleTargetsClassnames(
  element,
  elementTargetsIds,
  classNames,
  matchers,
  shouldCleanTargetValueOnMatch,
  shouldDisableTarget,
  shouldCheckTarget
) {
  elementTargetsIds.forEach((elementTargetId, index) => {
    const elementTarget = browser.document.getElementById(elementTargetId);
    const isMatching = !!element.value.match(new RegExp(matchers[index]));

    elementTarget.classList.toggle(classNames[index], isMatching);

    [
      ...elementTarget.querySelectorAll('input'),
      ...elementTarget.querySelectorAll('option'),
    ].forEach((elm) => {
      const elementInput = elm;
      if (isMatching && shouldCleanTargetValueOnMatch) {
        elementInput.value = '';
      }

      if (isMatching && shouldDisableTarget) {
        elementInput.disabled = 'true';
      } else {
        elementInput.removeAttribute('disabled');
      }

      if (isMatching && shouldCheckTarget) {
        elementInput.checked = 'true';
      }
    });
  });
}

const initClassToggler = () => {
  const elements = [...browser.document.querySelectorAll('.js-class-toggler')];

  elements.forEach((element) => {
    const elementTargetsIds = JSON.parse(element.getAttribute('data-class-toggler-targets-ids'));
    const matchers = JSON.parse(element.getAttribute('data-class-toggler-matchers'));
    const classNames = JSON.parse(element.getAttribute('data-class-toggler-classNames'));
    const shouldCleanTargetValueOnMatch =
      element.getAttribute('data-class-toggler-shouldCleanTargetValueOnMatch') === 'true';
    const shouldDisableTarget =
      element.getAttribute('data-class-toogler-shouldDisableTarget') === 'true';
    const shouldCheckTarget =
      element.getAttribute('data-class-toogler-shouldCheckTarget') === 'true';

    toggleTargetsClassnames(
      element,
      elementTargetsIds,
      classNames,
      matchers,
      shouldCleanTargetValueOnMatch,
      shouldDisableTarget,
      shouldCheckTarget
    );
    element.addEventListener('change', () => {
      toggleTargetsClassnames(
        element,
        elementTargetsIds,
        classNames,
        matchers,
        shouldCleanTargetValueOnMatch,
        shouldDisableTarget,
        shouldCheckTarget
      );
    });
  });
};

export default initClassToggler;
